/**
 * Lo stato vuoto di una vista, di una card o di un grafico: l'`Empty` di
 * shadcn con il titolo che dice cosa manca e, se serve, la descrizione che
 * dice perché o come riempirlo. Uno stato vuoto con un comando usa `Empty`
 * direttamente, con il comando in `EmptyContent`. Le regole sono in
 * `docs/navigazione-e-viste.md`, §1.12.
 */

import type { ReactNode } from 'react';
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@/components/ui/empty';

export function StatoVuoto({
  titolo,
  descrizione,
  className,
}: {
  titolo: ReactNode;
  descrizione?: ReactNode;
  className?: string;
}) {
  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyTitle>{titolo}</EmptyTitle>
        {descrizione && <EmptyDescription>{descrizione}</EmptyDescription>}
      </EmptyHeader>
    </Empty>
  );
}
